export default __webpack_public_path__ + "static/media/element_85.d9e1ac11.webp";